import React from 'react'

const FoSunshine = ({
    pageKey,
    patient,
    patientIndex,
    handleFieldChange,
    handleRowChange,
    handleSubtotalChange,
}) => {
    const tableHeaders = patient.table?.[0] ? Object.keys(patient.table[0]) : [];
    const isEmpty = (val) => val === null || val === "";


    return (
        <div className="border border-gray-300 rounded-md p-4 mb-8 bg-white shadow">
            <h3 className="text-xl font-semibold text-purple-700 italic mb-2">
                Patient Name:{" "}
                <span className="text-pink-600">{patient["Patient Name"] || "Unnamed"}</span>
            </h3>

            {/* Patient Header Info */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm mb-4">
                {Object.entries(patient)
                    .filter(([key]) => key !== "table" && key !== "subtotal")
                    .map(([key, value]) => (
                        <div key={key}>
                            <label className="font-semibold text-gray-700">{key}:</label>
                            <input
                                className={`!border p-1 w-full ${isEmpty(value) ? "border-2 border-red-700" : ""}`}
                                value={value || ""}
                                onChange={(e) =>
                                    handleFieldChange(pageKey, patientIndex, key, e.target.value)
                                }
                            />
                        </div>
                    ))}
            </div>

            {/* Table */}
            <div className="overflow-auto">
                <table className="w-full text-xs border border-gray-300">
                    <thead className="bg-gray-100">
                        <tr>
                            {tableHeaders.map((header, i) => (
                                <th key={i} className="border p-1 text-center whitespace-pre-line">
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {(patient.table || []).map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {tableHeaders.map((key, colIndex) => (
                                    <td key={colIndex} className="border p-1 text-center">
                                        <input
                                            className={`w-full text-center bg-white !border ${isEmpty(row[key]) ? "border-2 border-red-700" : ""
                                                }`}
                                            value={row[key] || ""}
                                            onChange={(e) =>
                                                handleRowChange(
                                                    pageKey,
                                                    patientIndex,
                                                    rowIndex,
                                                    key,
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </td>
                                ))}
                            </tr>
                        ))}

                        {/* Subtotal Row */}
                        {patient.subtotal && (
                            <tr className="bg-gray-50 font-semibold">
                                {tableHeaders.map((header, i) => (
                                    <td key={i} className="border p-1 text-center">
                                        <input
                                            className={`w-full text-center bg-white !border ${isEmpty(patient.subtotal[header]) ? "border-2 border-red-700" : ""
                                                }`}
                                            value={patient.subtotal[header] || ""}
                                            onChange={(e) =>
                                                handleSubtotalChange(
                                                    pageKey,
                                                    patientIndex,
                                                    header, // just the field key
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </td>
                                ))}
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default FoSunshine;
